// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './router/router'
import { routerMode } from './config/env'
import './config/rem'
import Mint from 'mint-ui'
import FastClick from 'fastclick'
import 'mint-ui/lib/style.css'
import './style/commonRules.css'
import Fetch from './config/fetch';
import $ from 'jquery'
import constantConfig from './common/config'
import hybrid_app from './common/hybrid_app'
import utils from './common/utils'
import vueTouch from 'kim-vue-touch'


import {
    MessageBox,
    Toast
} from 'mint-ui';

Vue.prototype.Fetch = Fetch;
Vue.prototype.constantConfig = constantConfig;
Vue.prototype.hybrid_app = hybrid_app;
Vue.use(Mint);
Vue.use(vueTouch)
constantConfig.loginParams = utils.parseUrl(location.href.replace('#/home', '')).loginParams && decodeURIComponent(utils.parseUrl(location.href.replace('#/home', '')).loginParams).replace(/\ /g, '+');
if ('addEventListener' in document) {
    document.addEventListener('DOMContentLoaded', function() {
        FastClick.attach(document.body);
    }, false);
}

window.onmousewheel = document.onmousewheel = function() { return false }

Vue.use(VueRouter)
const router = new VueRouter({
    routes,
    base: '/recommendationUI',
    mode: routerMode,
    strict: process.env.NODE_ENV !== 'production',
    scrollBehavior(to, from, savedPosition) {
        if (!constantConfig.loginParams) {
            //router.push('/error')
            Toast({
                message: '请先登录！',
                duration: 2000
            })
            return;
        }
        if (savedPosition) {
            return savedPosition
        } else {
            if (from.meta.keepAlive) {
                from.meta.savedPosition = document.body.scrollTop;
            }
            return { x: 0, y: to.meta.savedPosition || 0 }
        }

    },
})

window.router = router
router.beforeEach(function(to, from, next) {
    MessageBox.close(false)
    next();
});

new Vue({
    router,
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js